if (!customElements.get('product-comparison-table')) {
  class ProductComparisonTable extends HTMLElement {
    connectedCallback() {
      const utilTabs = this.querySelector('util-tabs');
      if (utilTabs) {
        const centerTab = utilTabs.querySelector('[data-comparison-center="true"]');
        if (centerTab && typeof utilTabs.activateTab === 'function') {
          requestAnimationFrame(() => {
            utilTabs.activateTab(centerTab, false);
            this.scheduleTitleMatchHeight();
          });
        } else {
          this.scheduleTitleMatchHeight();
        }
        utilTabs.addEventListener('click', (e) => {
          if (e.target.closest('[role="tab"]')) {
            this.scheduleTitleMatchHeight();
          }
        });
      } else {
        this.scheduleTitleMatchHeight();
      }
      if (typeof $s !== 'undefined' && $s.resizeWidthHandle) {
        $s.resizeWidthHandle(() => this.scheduleTitleMatchHeight(), 500);
      }
      if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => this.scheduleTitleMatchHeight());
      }
    }

    scheduleTitleMatchHeight() {
      if (this.titleMatchTimeout) {
        clearTimeout(this.titleMatchTimeout);
      }
      this.titleMatchTimeout = setTimeout(() => {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => this.runTitleMatchHeight());
        });
      }, 50);
    }

    runTitleMatchHeight() {
      const mobileWrap = this.querySelector('.product-comparison-table-mobile');
      const desktopWrap = this.querySelector('.product-comparison-table-desktop');
      const useMobile = mobileWrap && typeof $s !== 'undefined' && $s.isVisible(mobileWrap);
      const scope = useMobile ? mobileWrap : desktopWrap;
      if (!scope) return;

      if (useMobile) {
        const panels = Array.from(scope.querySelectorAll('[role="tabpanel"]'));
        if (!panels.length) return;
        this.matchTitleHeightsInTabPanels(panels, mobileWrap);
        return;
      }

      const titles = Array.from(scope.querySelectorAll('.comparison-card-title'));
      if (!titles.length) return;
      titles.forEach((title) => {
        title.style.minHeight = '';
      });
      if (typeof $s !== 'undefined' && $s.matchHeight) {
        $s.matchHeight(titles);
      }
    }

    matchTitleHeightsInTabPanels(panels, mobileWrap) {
      const activeTab = mobileWrap.querySelector('[role="tab"][aria-selected="true"]');
      const activePanelId = activeTab ? activeTab.getAttribute('aria-controls') : null;
      const titles = panels.map((panel) => panel.querySelector('.comparison-card-title')).filter(Boolean);
      if (!titles.length) return;

      titles.forEach((title) => {
        title.style.minHeight = '';
      });

      const measureWidth = mobileWrap.clientWidth || mobileWrap.getBoundingClientRect().width;
      let maxHeight = 0;

      panels.forEach((panel) => {
        panels.forEach((p) => p.setAttribute('hidden', 'hidden'));
        panel.removeAttribute('hidden');
        panel.style.position = 'absolute';
        panel.style.left = '0';
        panel.style.top = '0';
        panel.style.visibility = 'hidden';
        panel.style.pointerEvents = 'none';
        panel.style.width = measureWidth ? measureWidth + 'px' : '100%';
        panel.style.height = 'auto';
        panel.style.overflow = 'visible';

        void panel.offsetHeight;

        const title = panel.querySelector('.comparison-card-title');
        if (title) {
          maxHeight = Math.max(maxHeight, title.offsetHeight);
        }

        panel.style.position = '';
        panel.style.left = '';
        panel.style.top = '';
        panel.style.visibility = '';
        panel.style.pointerEvents = '';
        panel.style.width = '';
        panel.style.height = '';
        panel.style.overflow = '';
      });

      if (maxHeight > 0) {
        titles.forEach((title) => {
          title.style.minHeight = maxHeight + 'px';
        });
      }

      panels.forEach((panel) => {
        if (panel.id === activePanelId) {
          panel.removeAttribute('hidden');
        } else {
          panel.setAttribute('hidden', 'hidden');
        }
      });
    }
  }
  customElements.define('product-comparison-table', ProductComparisonTable);
}
